import Skeleton from 'react-loading-skeleton';
import React from 'react';

export const LatestTransactionsLoader = () => (
  <div className='flex flex-col items-center py-[40px] px-[40px] gap-[18px]'>
    {[1, 2, 3, 4, 5].map((i) => <Skeleton key={i} width='240px' height='30px' />)}
  </div>
);
